import type { FC } from 'react'
import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import TeamModalForm from 'modules/teams/components/TeamModalForm'
import { useCreateTeam } from 'modules/teams/hooks/useCreateTeam'
import type { TeamBasicInfo } from 'modules/teams/hooks/useTeamDetail'

const NewTeamPage: FC = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  track(trackingEvents.teams.createNewTeamStart)

  const { loading: creating, create } = useCreateTeam()

  const handleClose = () => {
    navigate(navigation.employees.teams.list.fullPath())
  }

  const handleOnSuccess = (team: TeamBasicInfo) => {
    if (team) {
      track(trackingEvents.teams.createNewTeamSubmit, {
        team_id: team.id,
        team_name: team.name,
      })
      navigate(navigation.employees.teams.id.fullPath({ id: team.id }))
    }
  }

  return (
    <TeamModalForm
      title={i18n.t('teams.add')}
      illustration="group"
      onClose={handleClose}
      loading={creating}
      onSubmit={create}
      onSuccess={handleOnSuccess}
    />
  )
}

export default NewTeamPage
